<template>
  <section
    class="features-tiles section"
    :class="[
      topOuterDivider && 'has-top-divider',
      bottomOuterDivider && 'has-bottom-divider',
      hasBgColor && 'has-bg-color',
      invertColor && 'invert-color',
    ]"
  >
    <div class="container">
      <div
        class="features-tiles-inner section-inner"
        :class="[
          topDivider && 'has-top-divider',
          bottomDivider && 'has-bottom-divider',
        ]"
      >
        <div class="tiles-wrap" :class="[pushLeft && 'push-left']">
          <div
            class="tiles-item reveal-from-bottom"
            data-reveal-container=".tiles-wrap"
            data-reveal-delay="200"
          >
            <div class="tiles-item-inner">
              <div class="features-tiles-item-header">
                <div class="features-tiles-item-image mb-16">
                  <c-image
                    :src="require('@/assets/images/feature-tile-icon-01.svg')"
                    alt="Feature tile icon 03"
                    :width="64"
                    :height="64"
                  />
                </div>
              </div>
              <div class="features-tiles-item-content">
                <h4 class="mt-0 mb-8">{{ $t("student.features.one.title") }}</h4>
                <p class="m-0 text-sm">{{ $t("student.features.one.text") }}</p>
              </div>
            </div>
          </div>

          <div
            class="tiles-item reveal-from-bottom"
            data-reveal-container=".tiles-wrap"
            data-reveal-delay="100"
          >
            <div class="tiles-item-inner">
              <div class="features-tiles-item-header">
                <div class="features-tiles-item-image mb-16">
                  <c-image
                    :src="require('@/assets/images/feature-tile-icon-02.svg')"
                    alt="Feature tile icon 02"
                    :width="64"
                    :height="64"
                  />
                </div>
              </div>
              <div class="features-tiles-item-content">
                <h4 class="mt-0 mb-8">{{ $t("student.features.two.title") }}</h4>
                <p class="m-0 text-sm">{{ $t("student.features.two.text") }}</p>
              </div>
            </div>
          </div>

          <div class="tiles-item reveal-from-bottom" data-reveal-container=".tiles-wrap">
            <div class="tiles-item-inner">
              <div class="features-tiles-item-header">
                <div class="features-tiles-item-image mb-16">
                  <c-image
                    :src="require('@/assets/images/feature-tile-icon-03.svg')"
                    alt="Feature tile icon 01"
                    :width="64"
                    :height="64"
                  />
                </div>
              </div>
              <div class="features-tiles-item-content">
                <h4 class="mt-0 mb-8">{{ $t("student.features.three.title") }}</h4>
                <p class="m-0 text-sm" v-html="$t('student.features.three.text')"></p>
              </div>
            </div>
          </div>

          <!--div
            class="tiles-item reveal-from-bottom"
            data-reveal-container=".tiles-wrap"
            data-reveal-delay="300"
          >
            <div class="tiles-item-inner">
              <div class="features-tiles-item-header">
                <div class="features-tiles-item-image mb-16">
                  <c-image
                    :src="require('@/assets/images/feature-tile-icon-04.svg')"
                    alt="Feature tile icon 04"
                    :width="64"
                    :height="64"
                  />
                </div>
              </div>
              <div class="features-tiles-item-content">
                <h4 class="mt-0 mb-8">{{ $t("student.features.four.title") }}</h4>
                <p class="m-0 text-sm">{{ $t("student.features.four.text") }}</p>
              </div>
            </div>
          </div>

          <div
            class="tiles-item reveal-from-bottom"
            data-reveal-container=".tiles-wrap"
            data-reveal-delay="500"
          >
            <div class="tiles-item-inner">
              <div class="features-tiles-item-header">
                <div class="features-tiles-item-image mb-16">
                  <c-image
                    :src="require('@/assets/images/feature-tile-icon-05.svg')"
                    alt="Feature tile icon 06"
                    :width="64"
                    :height="64"
                  />
                </div>
              </div>
              <div class="features-tiles-item-content">
                <h4 class="mt-0 mb-8">{{ $t("student.features.five.title") }}</h4>
                <p class="m-0 text-sm">{{ $t("student.features.five.text") }}</p>
              </div>
            </div>
          </div>

          <div
            class="tiles-item reveal-from-bottom"
            data-reveal-container=".tiles-wrap"
            data-reveal-delay="500"
          >
            <div class="tiles-item-inner">
              <div class="features-tiles-item-header">
                <div class="features-tiles-item-image mb-16">
                  <c-image
                    :src="require('@/assets/images/feature-tile-icon-06.svg')"
                    alt="Feature tile icon 06"
                    :width="64"
                    :height="64"
                  />
                </div>
              </div>
              <div class="features-tiles-item-content">
                <h4 class="mt-0 mb-8">{{ $t("student.features.six.title") }}</h4>
                <p class="m-0 text-sm">{{ $t("student.features.six.text") }}</p>
              </div>
            </div>
          </div-->
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { SectionTilesProps } from "@/utils/SectionProps.js";
import CImage from "@/components/elements/Image.vue";

export default {
  name: "CFeaturesTiles",
  components: {
    CImage,
  },
  mixins: [SectionTilesProps],
};
</script>
